<template>
    <div class="page-wrapper bg-white radius-lg padding margin-left-sm">
        <div class="search-container min flex align-center justify-between">
            <div class="flex align-center">
                <el-select v-model="cate" clearable placeholder="请选择项目类别">
                    <el-option
                        v-for="item in classifys"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                    </el-option>
                </el-select>
                <el-input class="margin-left-xs"  v-model="keyword" placeholder="请输入项目名称"></el-input>
                <el-button class="search-submit" type="primary" @click="search">搜索</el-button>
            </div>
            <router-link class="margin-left-xs" to="/web/staff/outcome/search">
                <el-button class="btn max bg-orange radius" type="warning">
                    关键字检索
                </el-button>
            </router-link>
        </div>
        <div class="page-list flex flex-direction margin-top-sm">
            <div class="document flex flex-direction radius margin-bottom-sm" v-for="(item,index) in lists" :key="index">
                <div class="flex flex-direction ">
                    <div class="document-name flex align-center justify-between padding-lr-sm">
                        <div class="title text-df text-red text-bold">
                            <i class="el-icon-folder-opened text-bold text-red margin-right-xs"></i>{{item.p_name}} - 成果汇总
                        </div>
                        <el-button class="btn small radius" size="small" @click="item.expand = !item.expand">
                            {{item.expand ? '收起' : '展开'}}
                        </el-button>
                    </div>
                    <el-divider v-if="(item.folder.enclosure.length || item.folder.folder.length) && item.expand"></el-divider>
                    <div class="margin-left-xl flex flex-direction" v-if="item.expand">
                        <div v-for="(file,position) in item.folder.enclosure" :key="position" class="margin-left-sm file flex align-center justify-between padding-right-xl">
                            <div class="flex-twice flex align-start justify-start">
                                <div :href="file.path" class="text-sm cursor" target="_blank" @click="previewFile(file)">
                                    {{ file.name }}
                                </div>
                            </div>
                            <div class="text-sm flex-sub">{{ file.create_time }}</div>
                        </div>
                        <div v-for="(item1,index1) in item.folder.folder" :key="index1" class="flex flex-direction">
                            <el-divider v-if="(!item.folder.enclosure.length && index1 !==0 ) || item.folder.enclosure.length"></el-divider>
                            <div class="document-name flex align-center justify-between padding-lr-sm">
                                <div class="title text-df text-orange">
                                    <i class="el-icon-folder-opened text-orange text-bold margin-right-xs"></i>{{ item1.name
                                    }}
                                </div>
                                <el-button class="btn small radius" size="small" @click="item1.expand = !item1.expand">
                                    {{item1.expand ? '收起' : '展开'}}
                                </el-button>
                            </div>
                            <el-divider v-if="(item1.enclosure.length || item1.folder.length) && item1.expand"></el-divider>
                            <div class="margin-left-xl flex flex-direction" v-if="item1.expand">
                                <div class="margin-left-sm flex flex-direction">
                                    <div v-for="(file,position) in item1.enclosure" :key="position" class="file flex align-center justify-between padding-right-xl">
                                        <div class="flex-twice flex align-start justify-start">
                                            <div :href="file.path" class="text-sm cursor" target="_blank" @click="previewFile(file)">
                                                {{ file.name }}
                                            </div>
                                        </div>
                                        <div class="text-sm flex-sub">{{ file.create_time }}</div>
                                    </div>
                                </div>
                                <div v-for="(item2,index2) in item1.folder" :key="index2" class="flex flex-direction radius">
                                    <el-divider v-if="(!item1.enclosure.length && index2 !==0 ) || item1.enclosure.length"></el-divider>
                                    <div class="document-name flex align-center justify-between padding-lr-sm">
                                        <div class="title text-df text-green">
                                            <i class="el-icon-folder-opened text-green text-bold margin-right-xs"></i>{{ item2.name
                                            }}
                                        </div>
                                        <el-button class="btn small radius" size="small" @click="item2.expand = !item2.expand">
                                            {{item2.expand ? '收起' : '展开'}}
                                        </el-button>
                                    </div>
                                    <el-divider v-if="item2.enclosure.length && item2.expand"></el-divider>
                                    <div class="margin-left-xl flex flex-direction" v-if="item2.expand">
                                        <div v-for="(file,position) in item2.enclosure" :key="position" class="file flex align-center justify-between padding-right-xl">
                                            <div class="flex-twice flex align-start justify-start">
                                                <div :href="file.path" class="text-sm cursor" target="_blank" @click="previewFile(file)">
                                                    {{ file.name }}
                                                </div>
                                            </div>
                                            <div class="text-sm flex-sub">{{ file.create_time }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <empty v-if="!lists.length" class="self-center"></empty>
            <el-pagination
                hide-on-single-page
                :current-page.sync="page"
                :page-size="limit"
                :total="total"
                background
                class="page-all margin-top self-end"
                layout="prev, pager, next"
                @current-change="init">
            </el-pagination>
        </div>
    </div>
</template>

<script>

import {getProjectCateList, getProjectPostOutcomeFile} from "@/api";
import {DOMAIN_HTTP} from "@/config";

export default {
    name: "outcome-list",
    components: {},
    data() {
        return {
            classifys: [],
            cate:'',
            keyword:'',
            lists: [],
            page: 1,
            limit: 10,
            total: 0,
            loading: false,
        }
    },
    created() {
        this.$emit('setIndex', [1,7], '项目成果汇总', false)
        this.getClassify()
        this.init()
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    methods: {
        async getClassify(){
            let _data = await getProjectCateList(1,1000)
            if (_data.status === 200)this.classifys = _data.data.data
        },
        async init() {
            this.loading = true
            let _data = await getProjectPostOutcomeFile(this.keyword,this.cate,'',this.page,this.limit)
            this.loading = false
            _data.data.data.map(item=>{
                item.expand = true
                item.folder.folder.map(item1=>{
                    item1.expand = true
                    item1.folder.map(item2=>{
                        item2.expand = true
                    })
                })
            })
            this.lists = _data.data.data
            this.total = _data.data.total
        },
        search() {
            this.page = 1
            this.init()
        },
        toPage(path) {
            this.$router.push(path)
        },
        previewFile(file) {
            const href= `${DOMAIN_HTTP}/file/preview?fid=${file.id}&type=3`
            window.open(href, '_blank')
        }
    },
    filters:{

    },

}
</script>

<style lang="scss" scoped>
.page-wrapper {
    .document {
        border: solid 1px #e6e6e6;

        .document-name {
            height: 81px;
        }

        .file {
            height: 55px;
        }

        .file + .file {
            border-top: 1px solid var(--ghostWhite);
        }
    }
}
</style>
